import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../sts-header/header.component';

@Component({
  selector: 'app-sts-header-banner',
  templateUrl: './sts-header-banner.component.html',
  styleUrls: ['./sts-header-banner.component.scss']
})
export class StsHeaderBannerComponent extends HeaderComponent implements OnInit {

}
